import {
  useAlerts,
} from '@dinosave/core/stores';
import type {
  AlertEntity,
} from '@dinosave/core/types';
import Alert from '@/components/Alert';

import styles from './Alerts.module.css';

const Alerts = () => {
  // ##########################################################################
  // STORES
  // ##########################################################################

  const alerts = useAlerts(s => s.alerts) || [];

  /* const alerts = [{
    id: '0433akfvfw02',
    image: 'http://localhost:3000/items/4656c3f78d2a556b3b44d7055d460de867e32a616497d03fa0f2a6e0d444d4f2/medium.jpeg',
    message: 'Purchased',
    position: 'bottom',
    timeout: 1900,
    title: 'Marked as',
    transition: 200,
    type: 'success',
  }, {
    id: '0433akfvfw03',
    message: 'Purchased123',
    position: 'bottom',
    timeout: 1900,
    title: 'Marked as',
    transition: 200,
    type: 'success',
  }, {
    id: '0433akfvfw03',
    message: 'Something went wrong',
    position: 'bottom',
    timeout: 1900,
    transition: 200,
    type: 'error',
  }]; */

  // ##########################################################################
  // RENDER
  // ##########################################################################

  if (
    !alerts.length
  ) return null;

  return (
    <div className={styles.alerts}>
      {alerts.map((alert: AlertEntity, index) => (
        <div
          key={index}
          className={styles.alert}
        >
          <Alert
            key={alert.id}
            alert={alert}
            index={index}
          />
        </div>
      ))}
    </div>
  );
};

export default Alerts;
